"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../theme");
exports.CSS = {
    container: 'c-Input',
    input: 'c-Input__input',
    label: 'c-Input__label',
    button: 'c-Input__button',
    error: 'c-input__error',
    isFullWidth: 'c-input--full-width',
    isCompact: 'c-input--is-compact',
    isFocused: 'c-Input--is-focused',
    isDirty: 'c-Input--is-dirty',
    isDisabled: 'c-input--is-disabled',
    isInvalid: 'c-input--is-invalid',
    MDL: {
        container: 'mdl-textfield mdl-textfield--floating-label',
        floatingLabel: 'mdl-textfield--floating-label',
        error: 'mdl-textfield__error',
        label: 'mdl-textfield__label',
        input: 'mdl-textfield__input',
        isFocused: 'is-focused',
        isDirty: 'is-dirty',
        isUpgraded: 'is-upgraded',
        isInvalid: 'is-invalid',
    },
};
exports.Style = {
    [exports.CSS.container]: {
        width: '100%',
    },
    [`${exports.CSS.container} .mdl-button`]: {
        right: 0,
        color: theme_1.DefaultTheme.font.color.supporting,
    },
    [`${exports.CSS.input}::-ms-clear`]: {
        // Hide clear button on input element for IE
        display: 'none',
    },
    [exports.CSS.isCompact]: {
        padding: 0,
    },
    [`${exports.CSS.isCompact} input`]: {
        outline: 'none',
        'font-family': 'Roboto Condensed',
        'font-size': '14px',
        padding: 0,
    },
    [`${exports.CSS.isCompact} textarea`]: {
        outline: 'none',
        'font-family': 'Roboto Condensed',
        'font-size': '14px',
        padding: 0,
    },
    [`${exports.CSS.isCompact} .mdl-textfield__label:after`]: {
        bottom: '0px',
    },
};
//# sourceMappingURL=input.style.js.map